import React, { useEffect, useMemo } from 'react';

import {
  ArchivedCategoryProvider,
  Bus,
  isEmptyCollection,
  useArchivedSportState,
} from '@atlas/core';
import { EmptyStateView, ResultsItemSkeleton, ResultsTournamentItemSkeleton } from '@atlas/ui';

import ResultsTournaments from './ResultsTournaments';

const ResultsListSkeleton = () => (
  <div className="results-list-skeleton">
    <ResultsItemSkeleton />
    <ResultsTournamentItemSkeleton />
  </div>
);

const CategoryList = () => {
  const { categories } = useArchivedSportState();

  const CategoryTournaments = useMemo(
    () =>
      categories.map((category, i) => (
        <ArchivedCategoryProvider category={category} key={category.id}>
          <ResultsTournaments forceIsExpanded={i === 0} />
        </ArchivedCategoryProvider>
      )),
    [categories],
  );

  if (!categories || isEmptyCollection(categories)) {
    return (
      <EmptyStateView
        className="result-no-item"
        description="results_empty_description"
        title="results_empty_message"
      />
    );
  }

  return (
    <div className="category-layout" id="category-layout">
      <h1 className="d-none">{categories[0].sportName}</h1>
      {CategoryTournaments}
    </div>
  );
};

const ResultsCategories = props => {
  const { id, loading } = useArchivedSportState();

  useEffect(() => {
    Bus.emit('ui:scroll:content', {
      behavior: 'auto',
      scrollTo: 0,
    });
  }, [id]);

  if (loading) {
    return <ResultsListSkeleton />;
  }

  return <CategoryList {...props} />;
};

export default ResultsCategories;
